import { useState } from "react";
import { ImagesSentSuccessContext } from "./context";
import { ImagesSentSuccessHandlers } from "./types";

export interface ImagesSentSuccessProviderProps {
  defaultHandlers?: ImagesSentSuccessHandlers;
  children?: React.ReactNode;
}

const defaultHandlers = {
  onTakeMore: (navigation: any) => undefined,
  onNewProduct: (navigation: any) => undefined,
  onFinished: (navigation: any) => undefined,
};

export function ImagesSentSuccessProvider({
  defaultHandlers: defaultHandlersProp,
  children,
}: ImagesSentSuccessProviderProps) {
  const [handlers, updateHandlers] = useState<ImagesSentSuccessHandlers>(
    defaultHandlersProp || defaultHandlers
  );

  return (
    <ImagesSentSuccessContext.Provider
      value={{
        updateHandlers,
        handlers,
      }}
    >
      {children}
    </ImagesSentSuccessContext.Provider>
  );
}
